import styled from 'styled-components'

export const StyledSeparator = styled.hr`
  width: 100%;
  height: 0;
  border-top-color: #d9d9d9;
  margin: 1rem 0;
`
